/* RESPONSIBLE TEAM: team-ai-agent */
import { attr } from '@ember-data/model';
import Fragment from 'ember-data-model-fragments/fragment';

export default Fragment.extend({
  identifier: attr('string'),
  text: attr('string'),
});
